import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { URLSearchParams } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import { User } from '../../models/user';
import { ENV } from '../../environments/environment';

@Injectable()
export class ProfilesService {
  private resourceEndpoint: string;
  public Profile: User;

  fetch(): Observable<User> {
    return this.http.get<any>(this.resourceEndpoint)
      .map(response => {return new User(response.data);});
  }

  getById(id, requestParams): Observable<any> {
    requestParams = typeof requestParams === "object" ? requestParams : {};

    let queryParams = new URLSearchParams();

    for(let key in requestParams)
    {
      queryParams.set(key, requestParams[key]);
    }

    return this.http.get<any>(`${this.resourceEndpoint}/${id}?` + queryParams.toString())
      .map(response => response.data);
  }

  search(searchParams: object): Observable<any[]> {
    let queryParams = new URLSearchParams();

    for(let key in searchParams)
    {
      queryParams.set(key, searchParams[key]);
    }

    return this.http.get<any>(`${this.resourceEndpoint}?` + queryParams.toString())
      .map(response => response.data);
  }

  set(Model) {
    this.Profile = Model;
  }

  get() {
    return this.Profile;
  }

  constructor(public http: HttpClient) {
    this.resourceEndpoint = `${ENV.apiUrl}/v${ENV.apiVersion}/profiles`;
  }
}



// WEBPACK FOOTER //
// ./src/services/users/profiles-service.ts